import React from "react";
import "./manufacturing.css";
import paintCans from "../assets/paintCans.png"; 
import wallColors from "../assets/wallColors.png"; 

export default function Manufacturing() {
  return (
    <section className="manufacturing">
      <h2>Manufacturing Excellence</h2>
      <p className="description">
        Our state-of-the-art manufacturing facilities employ the latest technology to ensure every batch of Glamur Paint meets international quality standards. 
        We source premium raw materials and employ rigorous quality control processes, making us a preferred choice for the best paints in Karachi and across Pakistan.
      </p>
      <a href="/" className="cert-link">Quality Certificates</a>

      <div className="carda-container">
        <div className="carda">
          <img src={paintCans} alt="Paint cans" />
          <h3>Our Commitment to Pakistan</h3>
          <p>
            As a proudly Pakistani company, we understand the unique challenges our climate and architecture present. 
            Our paints are specifically formulated to withstand Pakistan’s diverse weather conditions, 
            from the coastal humidity of Karachi to the extreme temperatures of interior Sindh Province.
          </p>
          <a href="/" className="read-more">Read More →</a>
        </div>

        <div className="carda">
          <img src={wallColors} alt="Wall colors" />
          <h3>Looking Forward</h3>
          <p>
            As we continue our journey, Glamur Paints remains committed to innovation, quality, and customer satisfaction. 
            We’re not just painting walls – we’re painting the future of Pakistani homes, one premium paint job at a time.
          </p>
          <a href="/" className="read-more">Read More →</a>
        </div>
      </div>
    </section>
  );
}
